module.exports = __webpack_public_path__ + "left.22wsWUt7.svg";